/**
 * @fileoverview Which courses are Foothill's. Shared because both the webapp
 * and the attendance callable have to agree: Foothill courses carry a Canvas
 * attendance grade alongside the ordinary section attendance.
 */

/**
 * The one Foothill course whose id predates the `cs49-` convention. Every
 * other Foothill course is identified by that prefix.
 */
const LEGACY_FOOTHILL_COURSE_ID = 'foothill-cs49';

/** The prefix every Foothill course id has carried since. */
const FOOTHILL_COURSE_ID_PREFIX = 'cs49-';

/**
 * Whether a course is run by Foothill College, which grades attendance in
 * Canvas.
 *
 * Accepts a missing id rather than only a string: courseless routes resolve
 * the current course to null, and `@cip/webapp` compiles with
 * `strictNullChecks` off, so a null reaches here without the compiler
 * objecting. See [#3832](https://github.com/CodeinPlace/cip/issues/3832) for
 * the crash that shape caused before.
 *
 * @param courseId The course id to test; null, undefined and the empty string
 *     all read as not-Foothill.
 * @return Whether the course is a Foothill course.
 * @throws Never.
 */
export function isFoothillCourse(courseId: string | null | undefined): boolean {
  if (!courseId) {
    return false;
  }
  return (
    courseId === LEGACY_FOOTHILL_COURSE_ID ||
    courseId.startsWith(FOOTHILL_COURSE_ID_PREFIX)
  );
}
